import {Campaign} from '../../../../types/src';

export function isCampaignInmail(campaign: Campaign) {
  return campaign && campaign.type && campaign.type.includes('inmail');
}
